import React from "react";
var __jsx = React.createElement;
import SingleTrendComponent from "@/pages/trends/TrendComponents/SingleTrend/SingleTrendComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
var SingleTrendPage = function SingleTrendPage() {
  var data = useFullPageData(PageNamesEnum.PAGE_NAME__TrendPermalink);
  if (!data) return null;
  var singleTrend = data.singleTrend,
    searchResults = data.searchResults;
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    authenticationMsg: true,
    mainClass: "",
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    hasMobFooter: true,
    loading: true
  }, /*#__PURE__*/React.createElement(SingleTrendComponent, {
    trend: singleTrend,
    posts: searchResults.posts,
    similarItems: searchResults.similarItems
  }));
};
export default SingleTrendPage;